import axios from "axios";
import { baseURL } from "../config/api";

export const post_CreateAppointment = (data: any) => {
    return axios({
        url: `${baseURL}appointments/CreateAppointmentForService`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
        data: data
    }).then(response => response.data);
}

export const post_UpdateAppointment = (data: any, userId: number) => {
    return axios({
        url: `${baseURL}appointments/CreateOrUpdateAppointmentForService?userId=${userId}`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
        data: data
    }).then(response => response.data);
}

export const post_comment = (data: any, userId: number) => {
    return axios({
        url: `${baseURL}comments?userId=${userId}`,
        method: "POST",
        withCredentials: false,
        data: data
    }).then(response => response.data);
}


export const getCustomerServices = () => {
    return getFetch(`services`)
}

export const getAppointmentWithDetails = (id: number) => {
    return getFetch(`appointments/GetAppointmentWithDetails/${id}`)
}

export const getAppointmentSummary = (id: number) => {
    return getFetch(`appointments/GetAppointmentSummary/${id}`)
}

export const getAppointmentTirePositions = (id: number) => {
    return getFetch(`appointmentTireServicePositions/GetAppointmentTireServicePositionsByAppointmentId/${id}`)
}

export const getStatus = (attributeName: string) => {
    return getFetch(`statuses/GetExpressStatusesByAttributeName/${attributeName}`)
}

export const getLoctionOpenHours = (locationId: number) => {
    return getFetch(`locationOpenHours/GetLocationOpenHoursByLocationId/${locationId}`)
}

export const getCommentsReportByAttributeAndAttributeId = (attributeName: string, attributeId: number) => {
    return getFetch(`comments/GetCommentReportByAttributeNameAndAttributeId?attributeName=${attributeName}&attributeId=${attributeId}`);
}

export const getDashboardBookingByLocationId = (locationId: number, dateType: string, startDate: string, endDate: string) => {
    return getFetch(`dashboardBookings/GetDashboardBookingsByLocationId?locationId=${locationId}&dateType=${dateType}&pickupDate=${startDate}&returnDate=${endDate}`);
}

export const getDashboardBooking = (dateType: string, startDate: string, endDate: string) => {
    return getFetch(`dashboardBookings?dateType=${dateType}&pickupDate=${startDate}&returnDate=${endDate}`);
}

export const delete_comment = (primaryKey: number, userId: number) => {
    return axios({
        url: `${baseURL}comments`,
        method: "DELETE",
        params: { id: primaryKey, userId: userId }
    }).then(response => response.data);
}


const getFetch = (url: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        params: params
    }).then(response => response.data);
}